import {
    COMPLETE_LEARNER_CONTENT_FAIL,
    COMPLETE_LEARNER_CONTENT_SUCCESS,
    FETCH_MODULE_PLAYER_FAIL,
    FETCH_MODULE_PLAYER_SUCCESS,
    RESET_MODULE_LEARNING_STATE,
    SET_CURRENT_LEARNER_CONTENT,
    SET_MODULE_LEARNING_ERROR,
    SET_MODULE_LEARNING_LOADING,
    START_LEARNER_CONTENT_FAIL,
    START_LEARNER_CONTENT_SUCCESS,
    START_LEARNER_MODULE_FAIL,
    START_LEARNER_MODULE_SUCCESS,
    UPDATE_LEARNER_CONTENT_PROGRESS_FAIL,
    UPDATE_LEARNER_CONTENT_PROGRESS_REQUEST,
    UPDATE_LEARNER_CONTENT_PROGRESS_SUCCESS,
} from "../actions/moduleLearningActions";

const initialState = {
    loading: false,
    error: null,
    player: null,
    sections: [],
    currentContentId: null,
    saveStatus: "idle",
    saveError: null,
    lastSavedAt: null,
    saveContentId: null,
};

const updateProgressInSections = (sections, progressPayload) =>
    (sections || []).map((section) => {
        if (String(section.id) !== String(progressPayload.sectionId)) {
            return section;
        }

        return {
            ...section,
            progress: progressPayload.sectionProgress || section.progress,
            contents: (section.contents || []).map((content) =>
                String(content.id) === String(progressPayload.contentId)
                    ? {
                        ...content,
                        progress: {
                            ...(content.progress || {}),
                            ...progressPayload,
                        },
                    }
                    : content
            ),
        };
    });

export default function moduleLearningReducer(state = initialState, action) {
    switch (action.type) {
        case SET_MODULE_LEARNING_LOADING:
            return { ...state, loading: action.payload };

        case SET_MODULE_LEARNING_ERROR:
            return { ...state, error: action.payload };

        case FETCH_MODULE_PLAYER_SUCCESS:
            return {
                ...state,
                player: action.payload || null,
                sections: action.payload?.sections || [],
                error: null,
                saveStatus: "idle",
                saveError: null,
            };

        case SET_CURRENT_LEARNER_CONTENT:
            return {
                ...state,
                currentContentId: action.payload,
            };

        case START_LEARNER_MODULE_SUCCESS:
            return {
                ...state,
                player: state.player
                    ? {
                        ...state.player,
                        lastContentId: action.payload?.lastContentId ?? state.player.lastContentId,
                        progress: action.payload || state.player.progress,
                    }
                    : state.player,
                error: null,
            };

        case START_LEARNER_CONTENT_SUCCESS:
        case UPDATE_LEARNER_CONTENT_PROGRESS_SUCCESS:
        case COMPLETE_LEARNER_CONTENT_SUCCESS:
            return {
                ...state,
                player: state.player
                    ? {
                        ...state.player,
                        lastContentId: action.payload?.contentId ?? state.player.lastContentId,
                        progress: action.payload?.moduleProgress || state.player.progress,
                    }
                    : state.player,
                sections: updateProgressInSections(state.sections, action.payload),
                error: null,
                saveStatus: action.type === UPDATE_LEARNER_CONTENT_PROGRESS_SUCCESS ? "saved" : state.saveStatus,
                saveError: null,
                lastSavedAt: action.type === UPDATE_LEARNER_CONTENT_PROGRESS_SUCCESS ? Date.now() : state.lastSavedAt,
                saveContentId: action.payload?.contentId ?? state.saveContentId,
            };

        case UPDATE_LEARNER_CONTENT_PROGRESS_REQUEST:
            return {
                ...state,
                saveStatus: "saving",
                saveError: null,
                saveContentId: action.payload?.contentId ?? state.saveContentId,
            };

        case FETCH_MODULE_PLAYER_FAIL:
        case START_LEARNER_MODULE_FAIL:
        case START_LEARNER_CONTENT_FAIL:
        case COMPLETE_LEARNER_CONTENT_FAIL:
            return { ...state, error: action.payload };

        case UPDATE_LEARNER_CONTENT_PROGRESS_FAIL:
            return {
                ...state,
                saveStatus: action.payload?.offline ? "offline" : "error",
                saveError: action.payload?.message || "Impossible de sauvegarder la progression.",
                saveContentId: action.payload?.contentId ?? state.saveContentId,
            };

        case RESET_MODULE_LEARNING_STATE:
            return initialState;

        default:
            return state;
    }
}
